export default {
  infoName: "称呼*",
  infoEmail: "邮箱*",
  infoCompanyName: "公司名称",
  infoMeg: "留言*",
  infoSubmit: "提交",
  moreUs1: "想了解更多",
  moreUs2: "请联系我们",
  
}